import Units from "../../../utils/Units";
import Percentage from "../axes/Percentage";
import Time from "../axes/Time";
import Day from "../axes/Day";

let HumidityDay = {
    type: "line",
    label: "Humidity",
    fill: true,
    lineTension: 0,
    colorPalette: 0,
    borderWidth:2,

    pointStyle: "circle",
    pointRadius:0,
    pointHoverRadius: 2,
    pointBorderWidth:.5,
    z:50,

    tooltipLabelValueCallback: (value) => {
        return Units.rounded(value,2);
    },

    yAxis:Percentage,
    xAxis:Day
};

export default HumidityDay;



// WEBPACK FOOTER //
// ./src/components/chart/channels/HumidityDay.js